import { Switch, Route } from "react-router-dom";
import { routes } from "./_constants";
import Header from "./components/header";
import RetiredScreen from "./screens/retiredScreen";

export default function AppRouter()
{
	return (
		<div className={'app'}>
			<Header />
			<div className={'app-content max-width-container'}>
				<Switch>
					<Route path={routes.home}>
						<RetiredScreen />
					</Route>
				</Switch>
			</div>
		</div>
	);
}
